import { defineStore } from 'pinia';
import { StateConfigModel } from '~app/core/config/types';
import { PUBLIC_PATH } from '~app/core/env';
import axios from 'axios';
import { deserialize } from '~app/shared/json-mapper';

export const STORE_ID = 'config';

export let configRequestPromise: Promise<StateConfigModel>;

export const useConfigStore = defineStore(STORE_ID, {
  state: (): StateConfigModel => ({
    apiUrl: '',
    sso: null,
    products: null,
    features: null,
  }),
  actions: {
    fetch() {
      if (configRequestPromise) {
        return configRequestPromise;
      }

      configRequestPromise = axios
        .get(PUBLIC_PATH + 'config/app.json')
        .catch(() => axios.get(PUBLIC_PATH + 'config/app.default.json'))
        .then(({ data }) => {
          this.$patch(deserialize(StateConfigModel, data));
          return this.$state;
        });

      return configRequestPromise;
    },
  },
});
